import type { Question } from '../components/survey/surveyTypes';

export const surveyQuestions: Question[] = [
  // VALUE COMPONENT
  
  // Intrinsic Goal Orientation
  {
    id: 1,
    text: "In a class like this, I prefer course material that really challenges me so I can learn new things.",
    category: "motivation",
    section: "Intrinsic Goal Orientation",
    questionType: "standard"
  },
  {
    id: 22,
    text: "The most satisfying thing for me in this course is trying to understand the content as thoroughly as possible.",
    category: "motivation",
    section: "Intrinsic Goal Orientation",
    questionType: "standard"
  },
  {
    id: 24,
    text: "When I have the opportunity in this class, I choose course assignments that I can learn from even if they don't guarantee a good grade.",
    category: "motivation",
    section: "Intrinsic Goal Orientation",
    questionType: "standard"
  },

  // Extrinsic Goal Motivation
  {
    id: 11,
    text: "The most important thing for me right now is improving my overall grade point average, so my main concern in this class is getting a good grade.",
    category: "motivation",
    section: "Extrinsic Goal Motivation",
    questionType: "standard"
  },
  {
    id: 13,
    text: "If I can, I want to get better grades in this class than most of the other students.",
    category: "motivation",
    section: "Extrinsic Goal Motivation",
    questionType: "standard"
  },
  {
    id: 30,
    text: "I want to do well in this class because it is important to show my ability to my family, friends, employer, or others.",
    category: "motivation",
    section: "Extrinsic Goal Motivation",
    questionType: "standard"
  },

  // Task Value
  {
    id: 4,
    text: "I think I will be able to use what I learn in this course in other courses.",
    category: "motivation",
    section: "Task Value",
    questionType: "standard"
  },
  {
    id: 17,
    text: "I am very interested in the content area of this course.",
    category: "motivation",
    section: "Task Value",
    questionType: "standard"
  },
  {
    id: 23,
    text: "I think the course material in this class is useful for me to learn.",
    category: "motivation",
    section: "Task Value",
    questionType: "standard"
  },

  // Control of Learning Beliefs
  {
    id: 2,
    text: "If I study in appropriate ways, then I will be able to learn the material in this course.",
    category: "motivation",
    section: "Control of Learning Beliefs",
    questionType: "standard"
  },
  {
    id: 9,
    text: "It is my own fault if I don't learn the material in this course.",
    category: "motivation",
    section: "Control of Learning Beliefs",
    questionType: "standard"
  },
  {
    id: 25,
    text: "If I try hard enough, then I will understand the course material.",
    category: "motivation",
    section: "Control of Learning Beliefs",
    questionType: "standard"
  },

  // Self-Efficacy for Learning and Performance
  {
    id: 5,
    text: "I believe I will receive an excellent grade in this class.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 6,
    text: "I'm certain I can understand the most difficult material presented in the readings for this course.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 12,
    text: "I'm confident I can learn the basic concepts taught in this course.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 15,
    text: "I'm confident I can understand the most complex material presented by the instructor in this course.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 20,
    text: "I'm confident I can do an excellent job on the assignments and tests in this course.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 21,
    text: "I expect to do well in this class.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 29,
    text: "I'm certain I can master the skills being taught in this class.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },
  {
    id: 31,
    text: "Considering the difficulty of this course, the teacher, and my skills, I think I will do well in this class.",
    category: "motivation",
    section: "Self-Efficacy for Learning and Performance",
    questionType: "standard"
  },

  // Test Anxiety
  {
    id: 3,
    text: "When I take a test I think about how poorly I am doing compared with other students.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 8,
    text: "When I take a test I think of the consequences of failing.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 14,
    text: "I have an uneasy, upset feeling when I take an exam.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 19,
    text: "I feel my heart beating fast when I take an exam.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 28,
    text: "When I take tests I think of the consequences of failing.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },

  // LEARNING STRATEGIES COMPONENT

  // Rehearsal
  {
    id: 39,
    text: "When I study the readings for this course, I outline the material to help me organize my thoughts.",
    category: "learning-strategies",
    section: "Rehearsal",
    questionType: "standard"
  },
  {
    id: 46,
    text: "When studying for this course, I read my class notes and the course readings over and over again.",
    category: "learning-strategies",
    section: "Rehearsal",
    questionType: "standard"
  },
  {
    id: 59,
    text: "I memorize key words to remind me of important concepts in this class.",
    category: "learning-strategies",
    section: "Rehearsal",
    questionType: "standard"
  },
  {
    id: 72,
    text: "When I study for this class, I practice saying the material to myself over and over.",
    category: "learning-strategies",
    section: "Rehearsal",
    questionType: "standard"
  },

  // Organization
  {
    id: 32,
    text: "When I study the readings for this course, I outline the material to help me organize my thoughts.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },
  {
    id: 42,
    text: "During class time I often miss important points because I'm thinking of other things.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },
  {
    id: 49,
    text: "When studying for this course, I read my class notes and the course readings over and over again.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },
  {
    id: 53,
    text: "I make good use of my study time for this course.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },
  {
    id: 63,
    text: "I find it hard to stick to a study schedule.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },
  {
    id: 67,
    text: "I have a regular place set aside for studying.",
    category: "learning-strategies",
    section: "Organization",
    questionType: "standard"
  },

  // Elaboration
  {
    id: 51,
    text: "When I read for this course, I ask myself questions to help focus my reading.",
    category: "learning-strategies",
    section: "Elaboration", 
    questionType: "standard"
  },
  {
    id: 61,
    text: "When I become confused about something I'm reading for this class, I go back and try to figure it out.",
    category: "learning-strategies",
    section: "Elaboration",
    questionType: "standard"
  },
  {
    id: 62,
    text: "If course readings are difficult to understand, I change the way I read the material.",
    category: "learning-strategies",
    section: "Elaboration",
    questionType: "standard"
  },
  {
    id: 64,
    text: "Before I study new course material thoroughly, I often skim it to see how it is organized.",
    category: "learning-strategies",
    section: "Elaboration",
    questionType: "standard"
  },
  {
    id: 69,
    text: "I try to work with other students from this class to complete the assignments.",
    category: "learning-strategies",
    section: "Elaboration",
    questionType: "standard"
  },
  {
    id: 81,
    text: "I ask myself questions to make sure I understand the material I have been studying in this class.",
    category: "learning-strategies",
    section: "Elaboration",
    questionType: "standard"
  },

  // Critical Thinking
  {
    id: 36,
    text: "I often find myself questioning things I hear or read in this course to decide if I find them convincing.",
    category: "learning-strategies",
    section: "Critical Thinking",
    questionType: "standard"
  },
  {
    id: 38,
    text: "When a theory, interpretation, or conclusion is presented in class or in the readings, I try to decide if there is good supporting evidence.",
    category: "learning-strategies",
    section: "Critical Thinking",
    questionType: "standard"
  },
  {
    id: 47,
    text: "I treat the course material as a starting point and try to develop my own ideas about it.",
    category: "learning-strategies",
    section: "Critical Thinking",
    questionType: "standard"
  },
  {
    id: 66,
    text: "I try to play around with ideas of my own related to what I am learning in this course.",
    category: "learning-strategies",
    section: "Critical Thinking",
    questionType: "standard"
  },
  {
    id: 71,
    text: "Whenever I read or hear an assertion or conclusion in this class, I think about possible alternatives.",
    category: "learning-strategies",
    section: "Critical Thinking",
    questionType: "standard"
  },

  // Metacognitive Self-Regulation
  {
    id: 33,
    text: "During class time I often miss important points because I'm thinking of other things.", 
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 41,
    text: "When reading for this course, I make up questions to help focus my reading.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 44,
    text: "If I become confused about something when I'm reading, I go back and try to figure it out.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 54,
    text: "If the readings are difficult to understand, I change the way I read the material.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 55,
    text: "Before I study new course material thoroughly, I often skim it to see how it is organized.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 56,
    text: "I ask myself questions to make sure I understand the material I have been studying in this class.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 57,
    text: "I try to change the way I study in order to fit the course requirements and instructor's teaching style.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 76,
    text: "I often find that I have been reading for class but don't know what it was all about.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 78,
    text: "When I study for this class, I set goals for myself in order to direct my activities in each study period.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },
  {
    id: 79,
    text: "If I get confused taking notes in class, I make sure I sort it out afterwards.",
    category: "learning-strategies",
    section: "Metacognitive Self-Regulation",
    questionType: "standard"
  },

  // Time and Study Environment
  {
    id: 35,
    text: "I usually study in a place where I can concentrate on my course work.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 43,
    text: "I make good use of my study time for this course.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 52,
    text: "I find it hard to stick to a study schedule.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 65,
    text: "I make sure I keep up with the weekly readings and assignments for this course.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 70,
    text: "I attend this class regularly.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 73,
    text: "I often find that I don't spend very much time on this course because of other activities.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 77,
    text: "I rarely find time to review my notes or readings before an exam.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },
  {
    id: 80,
    text: "I have a regular place set aside for studying.",
    category: "learning-strategies",
    section: "Time and Study Environment",
    questionType: "standard"
  },

  // Effort Regulation
  {
    id: 37,
    text: "I work hard to do well in this class even if I don't like what we are doing.",
    category: "learning-strategies",
    section: "Effort Regulation",
    questionType: "standard"
  },
  {
    id: 48,
    text: "When course work is difficult, I either give up or only study the easy parts.",
    category: "learning-strategies",
    section: "Effort Regulation",
    questionType: "standard"
  },
  {
    id: 60,
    text: "I work hard to do well in this class even if I don't like what we are doing.",
    category: "learning-strategies",
    section: "Effort Regulation",
    questionType: "standard"
  },
  {
    id: 74,
    text: "When course work is difficult, I give up or only study the easy parts.",
    category: "learning-strategies",
    section: "Effort Regulation",
    questionType: "standard"
  },

  // Peer Learning
  {
    id: 34,
    text: "When studying for this course, I often try to explain the material to a classmate or friend.",
    category: "learning-strategies",
    section: "Peer Learning",
    questionType: "standard"
  },
  {
    id: 45,
    text: "I try to work with other students from this class to complete the assignments.",
    category: "learning-strategies",
    section: "Peer Learning",
    questionType: "standard"
  },
  {
    id: 50,
    text: "When studying for this course, I often set aside time to discuss course material with a group of students from the class.",
    category: "learning-strategies",
    section: "Peer Learning",
    questionType: "standard"
  },

  // Help Seeking
  {
    id: 40,
    text: "Even if I have trouble learning the material in this class, I try to do the work on my own, without help from anyone.",
    category: "learning-strategies",
    section: "Help Seeking",
    questionType: "standard"
  },
  {
    id: 58,
    text: "I ask the instructor to clarify concepts I don't understand well.",
    category: "learning-strategies",
    section: "Help Seeking",
    questionType: "standard"
  },
  {
    id: 68,
    text: "When I can't understand the material in this course, I ask another student in this class for help.",
    category: "learning-strategies",
    section: "Help Seeking",
    questionType: "standard"
  },
  {
    id: 75,
    text: "I try to identify students in this class whom I can ask for help if necessary.",
    category: "learning-strategies",
    section: "Help Seeking",
    questionType: "standard"
  },

  // Additional Questions for Extended Survey

  // College Activities (Questions 82-97)
  {
    id: 82,
    text: "Participate in student government.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 83,
    text: "Participate in student clubs/groups.",
    category: "motivation",
    section: "College Activities", 
    questionType: "college-activities"
  },
  {
    id: 84,
    text: "Participate in a study abroad program.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 85,
    text: "Participate in volunteer or community service work.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 86,
    text: "Participate in internship programs.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 87,
    text: "Work on a professor's research project.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 88,
    text: "Come to class without completing readings or assignments.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 89,
    text: "Work on your own creative project (e.g. art, music, writing, etc.).",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 90,
    text: "Participate in intramural sports.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 91,
    text: "Participate in varsity sports.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 92,
    text: "Work for pay (on or off campus).",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 93,
    text: "Participate in fraternities or sororities.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 94,
    text: "Socialize with students of different racial/ethnic groups.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 95,
    text: "Participate in demonstrations.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 96,
    text: "Vote in student elections.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },
  {
    id: 97,
    text: "Vote in local, state, or national elections.",
    category: "motivation",
    section: "College Activities",
    questionType: "college-activities"
  },

  // Peer Learning Frequency (Questions 98-119)
  {
    id: 98,
    text: "Explain course material to one or more students.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 99,
    text: "Ask other students to explain course material to you.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 100,
    text: "Prepare for exams by discussing or working through course material with other students.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 101,
    text: "Work with other students on projects during class.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 102,
    text: "Work with classmates outside of class to prepare class assignments.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 103,
    text: "Tutor other students (paid or voluntary).",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 104,
    text: "Participate in a study group.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 105,
    text: "Ask classmates for information related to a course you missed.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 106,
    text: "Discuss ideas from your readings or classes with others outside of class (students, family members, co-workers, etc.).",
    category: "learning-strategies", 
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 107,
    text: "Discuss ideas from your readings or classes with faculty members outside of class.",
    category: "learning-strategies",
    section: "Peer Learning Frequency", 
    questionType: "peer-learning-frequency"
  },
  {
    id: 108,
    text: "Receive prompt feedback from faculty on your academic performance (written or oral).",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 109,
    text: "Work harder than you thought you could to meet an instructor's standards or expectations.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 110,
    text: "Work with faculty members on activities other than coursework (committees, orientation, student life activities, etc.).",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 111,
    text: "Discuss career plans with a faculty member or advisor.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 112,
    text: "Discuss assignments or grades with an instructor.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 113,
    text: "Skip class.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },
  {
    id: 114,
    text: "Come to class without completing readings or assignments.",
    category: "learning-strategies",
    section: "Peer Learning Frequency",
    questionType: "peer-learning-frequency"
  },

  // Group Behavior Questions (115-119)
  {
    id: 115,
    text: "I prefer to work independently rather than in groups.",
    category: "learning-strategies",
    section: "Group Behavior",
    questionType: "work-preference"
  },
  {
    id: 116,
    text: "I contribute actively to group discussions.",
    category: "learning-strategies",
    section: "Group Behavior",
    questionType: "participation-frequency"
  },
  {
    id: 117,
    text: "I find group work more effective than working alone.",
    category: "learning-strategies",
    section: "Group Behavior",
    questionType: "work-preference"
  },
  {
    id: 118,
    text: "I take on leadership roles in group settings.",
    category: "learning-strategies",
    section: "Group Behavior",
    questionType: "group-behavior"
  },
  {
    id: 119,
    text: "I prefer to have clear guidelines when working in groups.",  
    category: "learning-strategies",
    section: "Group Behavior",
    questionType: "work-preference"
  },

  // Test Anxiety - Additional Questions (120-122)
  {
    id: 120,
    text: "I worry about my ability to perform well on tests.",
    category: "motivation",
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 121,
    text: "I feel stressed when preparing for exams.",
    category: "motivation", 
    section: "Test Anxiety",
    questionType: "standard"
  },
  {
    id: 122,
    text: "I have trouble sleeping before important tests.",
    category: "motivation",
    section: "Test Anxiety", 
    questionType: "standard"
  },

  // Time Allocation Questions (123-134)
  {
    id: 123,
    text: "Preparing for class (studying, reading, writing, doing homework or lab work, analyzing data, rehearsing, and other academic activities)",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 124,
    text: "Working for pay on campus",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 125,
    text: "Working for pay off campus",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 126,
    text: "Participating in co-curricular activities (organizations, campus publications, student government, fraternity or sorority, intercollegiate or intramural sports, etc.)",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 127,
    text: "Relaxing and socializing (watching TV, partying, etc.)",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 128,
    text: "Providing care for dependents living with you (parents, children, spouse, etc.)",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 129,
    text: "Commuting to campus (driving, walking, etc.)",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 130,
    text: "Participating in household/family responsibilities not already mentioned above",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 131,
    text: "Participating in community service or volunteer work",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 132,
    text: "Participating in religious/spiritual activities",
    category: "learning-strategies",
    section: "Time Allocation", 
    questionType: "time-allocation"
  },
  {
    id: 133,
    text: "Participating in exercise/sports",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  },
  {
    id: 134,
    text: "Working on hobbies",
    category: "learning-strategies",
    section: "Time Allocation",
    questionType: "time-allocation"
  }
];

// Question count by category for validation
export const QUESTION_COUNTS = {
  TOTAL: 114,
  MOTIVATION: 31,
  LEARNING_STRATEGIES: 83
};

// Helper function to get questions by category
export const getQuestionsByCategory = (category: 'motivation' | 'learning-strategies') => {
  return surveyQuestions.filter(q => q.category === category);
};

// Helper function to get questions by section
export const getQuestionsBySection = (section: string) => {
  return surveyQuestions.filter(q => q.section === section);
};

// Helper function to get question by ID
export const getQuestionById = (id: number) => {
  return surveyQuestions.find(q => q.id === id);
};